import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { toast } from '@/hooks/use-toast';
import { Copy, Phone, MessageCircle } from 'lucide-react';

export const WHATSAPP_NUMBER_RAW = '5581998289611';
export const WHATSAPP_NUMBER_DISPLAY = '+55 (81) 99828-9611';
export const WHATSAPP_MESSAGE = 'Olá! Gostaria de conhecer a plataforma GEROBRA e solicitar acesso.';
export const WHATSAPP_WA_ME = `https://wa.me/${WHATSAPP_NUMBER_RAW}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
export const WHATSAPP_WEB_URL = `https://web.whatsapp.com/send?phone=${WHATSAPP_NUMBER_RAW}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
export const WHATSAPP_APP_URL = `whatsapp://send?phone=${WHATSAPP_NUMBER_RAW}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export function WhatsAppContactPopover({ trigger, align = 'end' }: { trigger: React.ReactNode; align?: 'start' | 'center' | 'end' }) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(WHATSAPP_NUMBER_DISPLAY);
      toast({ title: 'Número copiado', description: WHATSAPP_NUMBER_DISPLAY });
    } catch {
      toast({ title: 'Não foi possível copiar', description: WHATSAPP_NUMBER_DISPLAY });
    }
  };
  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent align={align} className="w-80 p-4 z-50 bg-popover">
        <div className="space-y-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Solicitar acesso</p>
            <p className="text-sm mt-1">Fale com o administrador da plataforma pelo WhatsApp:</p>
          </div>
          <div className="flex items-center justify-between gap-2 rounded-lg border bg-muted/40 p-3">
            <span className="font-mono text-sm font-semibold">{WHATSAPP_NUMBER_DISPLAY}</span>
            <Button size="sm" variant="ghost" onClick={copy} className="h-8 px-2">
              <Copy className="h-4 w-4" />
            </Button>
          </div>
          <div className="grid grid-cols-1 gap-2">
            <a href={WHATSAPP_WA_ME} target="_blank" rel="noopener noreferrer">
              <Button className="w-full text-white" style={{ background: '#25D366' }}>
                <MessageCircle className="mr-2 h-4 w-4" /> Abrir no WhatsApp
              </Button>
            </a>
            <a href={WHATSAPP_WEB_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="w-full">
                <MessageCircle className="mr-2 h-4 w-4" /> WhatsApp Web
              </Button>
            </a>
            <a href={WHATSAPP_APP_URL}>
              <Button variant="outline" className="w-full">
                <Phone className="mr-2 h-4 w-4" /> Abrir app do celular
              </Button>
            </a>
          </div>
          <p className="text-[11px] text-muted-foreground leading-relaxed">
            Se algum link estiver bloqueado pela sua rede, copie o número e adicione manualmente no WhatsApp.
          </p>
        </div>
      </PopoverContent>
    </Popover>
  );
}
